import React, { useEffect, useState, useContext } from "react";
import { Helmet } from "react-helmet";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import {
  getSurvey,
  postSurvey,
} from "../../../services/Api/Module/Customer";

import HeaderPageTitle from "../../../layouts/inc/HeaderPageTitle";

import ModalContext from "../../../contexts/ModalContext";

import { breakKeyDownEnter } from "../../../services/helper";

import img_icoTitleLogo from "../../../assets/img/ci/ico-title-logo.svg";

const Questionnaire = () => {
  const { modalAlert } = useContext(ModalContext); // import modal

  const stateProfile = useSelector((state) => state.profile);

  const navigate = useNavigate();

  /* Form */
  const {
    register,
    handleSubmit,
    formState: { isValid },
  } = useForm();

  // console.log("isValid: ", isValid);
  /* End Form */

  /* Handle click submit form */
  const onSubmit = (data) => {
    // console.log("onSubmit >>", data);

    let payload = {
      custId: stateProfile.dataUser.id,
      survey: [],
    };

    Object.entries(data.q).forEach(([key, val]) => {
      const tmpData = {
        questionId: key,
        answerList: Array.isArray(val) ? val : [val],
      };

      payload.survey.push(tmpData);
    });

    // console.log("payload >>", payload);

    submitSurvey(payload).then((_rsData) => {
      // console.log("_rsData >>", _rsData);

      if (_rsData.status === true) {
        navigate("/member");
      } else {
        console.warn(_rsData);
      }
    });
  };

  const submitSurvey = async (payload) => {
    let _return = {
      status: false,
      result: null,
    };

    try {
      const { data } = await postSurvey({ data: payload });
      // console.log("data.body >>", data);
      if (data.resultCode === 20201) {
        const resData = data.body;
        // console.log("submitSurvey resData >>", resData);

        _return.status = true;
        _return.result = resData;
      } else {
        console.warn(data);
      }
    } catch (e) {
      console.log("ERR submitSurvey >> ", e);
    }

    return _return;
  };
  /* End Handle click submit form */

  /* First event render */
  const [question, setQuestion] = useState([]);

  const handleGetQuestion = () => {
    loadSurvey({
      custId: stateProfile.dataUser.id,
    }).then((_rsDataSurvey) => {
      // console.log(_rsDataSurvey);

      if (
        _rsDataSurvey.result !== null &&
        Object.keys(_rsDataSurvey.result).length !== 0
      ) {
        setQuestion(_rsDataSurvey.result);
      }
    });
  };

  const loadSurvey = async (payload) => {
    let _return = {
      status: false,
      result: null,
    };

    try {
      const { data } = await getSurvey({ params: payload });
      if (data.resultCode === 20200) {
        const resData = data.body;
        // console.log("loadSurvey resData >>", resData);

        _return.status = true;
        _return.result = resData;
      } else {
        console.warn(data);
      }
    } catch (e) {
      console.log("ERR loadSurvey >> ", e);
    }

    return _return;
  };

  useEffect(() => {
    // console.log("useEffect !", stateProfile);

    if (Object.keys(stateProfile.dataUser).length !== 0) {
      handleGetQuestion();
    } else {
      navigate("/");
    }
  }, []);
  /* End First event render */

  return (
    <>
      <Helmet>
        <title>Paypoint</title>
        <meta name="title" content="Paypoint" />
        <meta name="description" content="" />
        <meta name="keyword" content="" />
        <meta property="og:title" content="Paypoint" />
        <meta property="og:description" content="" />
        <meta property="og:image" content="" />
        <meta property="og:url" content="" />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Paypoint" />
      </Helmet>

      <div id="pageQuestionnaire">
        <main>
          <div className="wrapContent">
            <HeaderPageTitle title="แบบสอบถาม" prevPage="/profile" />

            <form
              onSubmit={handleSubmit(onSubmit)}
              onKeyDown={(e) => breakKeyDownEnter(e)}
            >
              <section id="pQuestionMain">
                <div className="bQuestion">
                  <div className="bTitle">
                    <img src={img_icoTitleLogo} alt="" />
                    <div className="pageStep question">
                      <div className="step active"></div>
                      <div className="step active"></div>
                      <div className="step active"></div>
                    </div>
                    <p>ลงทะเบียนขั้นตอนสุดท้ายแล้ว!</p>
                  </div>

                  <div className="bForm">
                    <div className="bRow">
                      <div className="control-group question">
                        <p className="tTitle">
                          ตอบคำถามกับเรา เพื่อให้เราได้เข้าใจคุณมากขึ้น
                        </p>
                        {question.length > 0 &&
                          question.map((questionVal, questionIdx) => (
                            <div
                              className="bQuestionnaire"
                              key={questionVal.questionId}
                            >
                              <p className="tQuestion">
                                {`${questionIdx + 1}. ${
                                  questionVal.questionName
                                }`}
                              </p>

                              {questionVal.isMultiAnswer === 1
                                ? questionVal.answerList.map(
                                    (answer_val, answer_idx) => (
                                      <label
                                        className="control control--checkbox"
                                        key={answer_val.id}
                                      >
                                        <p className="">{answer_val.name}</p>
                                        <input
                                          {...register(
                                            `q.${questionVal.questionId}`,
                                            { required: true }
                                          )}
                                          type="checkbox"
                                          value={answer_val.id}
                                          defaultChecked={answer_val?.isSelected ?? false}
                                        />
                                        <div className="control__indicator"></div>
                                      </label>
                                    )
                                  )
                                : questionVal.answerList.map(
                                    (answer_val, answer_idx) => (
                                      <label
                                        className="control control--radio"
                                        key={answer_val.id}
                                      >
                                        <p className="">{answer_val.name}</p>
                                        <input
                                          {...register(
                                            `q.${questionVal.questionId}`,
                                            { required: true }
                                          )}
                                          type="radio"
                                          value={answer_val.id}
                                          defaultChecked={answer_val?.isSelected ?? false}
                                        />
                                        <div className="control__indicator"></div>
                                      </label>
                                    )
                                  )}
                            </div>
                          ))}
                      </div>
                    </div>

                    {/* <p className="tError">Text Error Main Form</p> */}
                  </div>
                </div>
              </section>
              <section id="pActionBtn">
                <div className="bBtn">
                  <button
                    className="btn"
                    type="submit"
                    disabled={isValid ? false : true}
                  >
                    ยืนยัน
                  </button>
                </div>
              </section>
            </form>
          </div>
        </main>
      </div>
    </>
  );
};

export default Questionnaire;
